module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/349b0239e42fd2ba945315b0571ad07b.png";